module.exports = __webpack_public_path__ + "img/selo_site_seguro_certisign.b81decd.png";